import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponse,
  RecalculateBackofficeUnansweredQuestionTopicsResponseDataSchema,
} from "schema"
import { z } from "zod"

type Response = DataResponse<
  z.infer<typeof RecalculateBackofficeUnansweredQuestionTopicsResponseDataSchema>
>

export function useRecalculateUnansweredQuestionTopics() {
  return useMutation({
    mutationFn: async () => {
      const { data } = await axios.post<Response>(
        "/backoffice/knowledge/unanswered-topics/recalculate",
        {},
      )
      return data.data
    },
  })
}
